import { yupResolver } from "@hookform/resolvers/yup";
import React, { useEffect } from "react";
import { useForm } from "react-hook-form";
import { SdsForm } from "soft_digi";
import { SdsFormElementProps } from "soft_digi/dist/sdforms/SdsFromInterFace";
import * as Yup from "yup";
import { SESSION_URLS } from "../../api/AdminUrls";
import { useSiteContext } from "../../contexts/SiteProvider";

import { post } from "../../services/smartApiService";

interface HeaderProps {
  loadTableData: () => void;
  dataIn: any;
  session_id: number;
}
const schema = Yup.object({
  ename: Yup.string().required("Name is required"),
  mobile_no: Yup.string()
    .matches(/^\d{10}$/, "Mobile number must be exactly 10 digits")
    .required("Mobile number is required"),
  euserid: Yup.string()
    .matches(/^\S*$/, "Employee ID cannot contain spaces")
    .required("Employee ID is required"),
  loco_shed: Yup.string().required("Loco Shed Name is required"),
});

const SessionUserAdditionForm: React.FC<HeaderProps> = ({
  loadTableData,
  dataIn,
  session_id,
}) => {
  const {
    control,
    handleSubmit,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(schema),
    defaultValues: dataIn,
  });
  const { closeModal } = useSiteContext();

  const onSubmit = (data: any) => {
    let url = SESSION_URLS.INSERT_USER;
    data["session_id"] = session_id;
    const subscription = post(url, data).subscribe((response) => {
      if (loadTableData) {
        loadTableData();
      }
      //console.log("response form ", response.data);
      closeModal();
    });
    return () => {
      subscription.unsubscribe();
    };
  };

  useEffect(() => {}, []);

  const elements: SdsFormElementProps[] = [
    {
      type: "TEXT_BOX",
      width: 6,
      name: "ename",
      element: {
        label: "Name",
        isRequired: true,
        inputType: "BORDER_LABEL",
      },
    },
    {
      type: "TEXT_BOX",
      width: 6,
      name: "mobile_no",
      element: {
        label: "Mobile Number",
        isRequired: true,
        inputType: "BORDER_LABEL",
        max: 10,
      },
    },
    {
      type: "TEXT_BOX",
      width: 6,
      name: "euserid",
      element: {
        label: "Employee ID",
        isRequired: true,
        inputType: "BORDER_LABEL",
      },
    },
    {
      type: "TEXT_BOX",
      width: 6,
      name: "loco_shed",
      element: {
        label: "Enter Loco Shed Name",
        isRequired: true,
        inputType: "BORDER_LABEL",
      },
    },

        {
      type: "TEXT_BOX",
      width: 6,
      name: "reporting_place",
      element: {
        label: "Reporting Place",
        // isRequired: true,
        inputType: "BORDER_LABEL",
      },
    },
        {
      type: "TEXT_BOX",
      width: 6,
      name: "designation",
      element: {
        label: "Designation",
        // isRequired: true,
        inputType: "BORDER_LABEL",
      },
    },

    {
      type: "BUTTON",
      width: 12,
      name: "submit_button",
      class_name: "has-text-right",
      element: {
        classList: ["button", "smart-action-button"],
        label: dataIn.ID ? "Update" : "Add",
        onClick: handleSubmit(onSubmit),
      },
    },
  ];
  return (
    <>
      <div className="sd-hims-input">
        <SdsForm elements={elements} errors={errors} control={control} />
      </div>
    </>
  );
};

export default SessionUserAdditionForm;
